export default [
    {
        path: '/pages/partner/PartnerOrders',
        name: '/pages/partner/PartnerOrders',
        component: () => import('@/views/partner/PartnerOrders.vue')
    },
    {
        path: '/pages/partner/partnerPool',
        name: '/pages/partner/partnerPool',
        component: () => import('@/views/partner/partnerPool.vue')
    },
    {
        path: '/pages/partner/transferPartnerGoods',
        name: '/pages/partner/transferPartnerGoods',
        component: () => import('@/views/partner/transferPartnerGoods.vue')
    },
    {
        path: '/pages/partner/partnerGoods',
        name: '/pages/partner/partnerGoods',
        component: () => import('@/views/partner/partnerGoods.vue')
    },
    {
        path: '/pages/partner/partnerLog',
        name: '/pages/partner/partnerLog',
        component: () => import('@/views/partner/partnerLog.vue')
    }
] 